import { makeColumnPrefs } from '@/lib/tableColumnPrefs';

// VLAN・IP 管理 / 一覧 tab のカラム設定。
export const IP_LIST_COLUMN_DEFS = [
  { key: 'ip_address', label: 'IPアドレス', defaultOn: true, fixed: true }, // primary
  { key: 'status', label: '状態', defaultOn: true },
  { key: 'device_name', label: 'デバイス名', defaultOn: true },
  { key: 'user', label: '使用者', defaultOn: true },
  { key: 'mac_address', label: 'MACアドレス', defaultOn: true },
  { key: 'purpose', label: '用途', defaultOn: true },
];

export const ipListCols = makeColumnPrefs(IP_LIST_COLUMN_DEFS, 'it_iplist_cols_v1');
